import { createFileRoute } from "@tanstack/react-router";
import { TermlyPolicyPage } from "@/knowmeno/TermlyPolicyPage";

export const Route = createFileRoute("/disclaimer")({
  head: () => ({
    meta: [
      { title: "Disclaimer — KnowMeno" },
      { name: "description", content: "KnowMeno is a personal wellness tracking tool — not a medical device. Learn how to use it alongside care from a qualified healthcare provider." },
      { property: "og:title", content: "Disclaimer — KnowMeno" },
      { property: "og:description", content: "KnowMeno is a personal wellness tracking tool — not a medical device. Learn how to use it alongside care from a qualified healthcare provider." },
      { property: "og:url", content: "https://knowmeno.com/disclaimer" },
    ],
    links: [
      { rel: "canonical", href: "https://knowmeno.com/disclaimer" },
      { rel: "alternate", hrefLang: "en", href: "https://knowmeno.com/disclaimer" },
      { rel: "alternate", hrefLang: "x-default", href: "https://knowmeno.com/disclaimer" },
    ],
  }),
  component: () => (
    <TermlyPolicyPage dataId="6062b79c-9581-4c29-9ff6-ce770aa848a3" title="Disclaimer" />
  ),
});
